import { styled } from 'goober';
import { useEffect, useState } from 'preact/hooks';

import { IQuizItem } from '../../types/quiz';
import { Button } from '../buttons/Button';
import { OptionButtons } from '../parts/OptionButtons';
import { QuestionImage } from '../parts/QuestionImage';
import { QuestionText } from '../parts/QuestionText';

type Props = {
  item: IQuizItem;
  onSubmit: (value: string | string[]) => void;
};

export const MultipleQuestion = ({ item, onSubmit }: Props) => {
  const [valid, setValid] = useState(false);
  const [values, setValues] = useState<Record<string, boolean>>({});

  const submit = () => onSubmit(Object.keys(values));
  const onSelect = (value: string) => {
    const newValues = { ...values };
    if (newValues[value]) {
      delete newValues[value];
    } else {
      newValues[value] = true;
    }
    setValues(newValues);
  };

  useEffect(() => {
    const isValid = Object.keys(values).length > 0;
    setValid(isValid);
  }, [values]);

  return (
    <Container>
      <QuestionImage item={item} />
      <QuestionText item={item} />
      <OptionButtons item={item} onSubmit={onSelect} selected={values} />
      <div style={{ height: '10px' }} />
      <Button className="q-cta-button" disabled={!valid} onClick={submit}>
        {item.cta || 'Continue'}
      </Button>
    </Container>
  );
};

const Container = styled('div')`
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
